import CreatePollModal from './CreatePollModal';
import PostPoll from './PostPoll';
import EditPollModal from './EditPollModal';
import ListVotersModal from './ListVotersModal';
import PollForm from './PollForm';
import ComposePollHero from './ComposePollHero';
import ComposePollPage from './ComposePollPage';
import PollsPage from './PollsPage';
import PollView from './PollView';
import PollViewPage from './PollViewPage';
import PollSubmitButton from './Poll/PollSubmitButton';
import PollOption from './Poll/PollOption';
import PollOptions from './Poll/PollOptions';
import PollsShowcasePage from './PollsShowcasePage';
import PollShowcase from './PollShowcase';
import PollShowcaseItem from './PollShowcaseItem';
import { AbstractPollPage } from './AbstractPollPage';
import PollTitle from './Poll/PollTitle';
import PollSubtitle from './Poll/PollSubtitle';
import PollImage from './Poll/PollImage';
import PollListItem from './Poll/PollListItem';
import PollList from './Poll/PollList';

export const components = {
  CreatePollModal,
  PostPoll,
  EditPollModal,
  ListVotersModal,
  PollForm,
  ComposePollHero,
  ComposePollPage,
  PollsPage,
  PollView,
  PollViewPage,
  PollSubmitButton,
  PollOption,
  PollOptions,
  PollsShowcasePage,
  PollShowcase,
  PollShowcaseItem,
  AbstractPollPage,
  PollTitle,
  PollSubtitle,
  PollImage,
  PollListItem,
  PollList,
};
